import React from 'react';
import {
    Form,
    Label, Input,
    Button, ListGroup, ListGroupItem, Row, Col
} from 'reactstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CostAdjustmentApi from '../../api/costAdjustmentapi';
import {formatDate} from '../../helpers';


class CostAdjustmentEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            costAdjustment: {adjustmentType: '', adjustment: '', startDate: '', endDate: '', costAdjustmentId: this.props.match.params.costAdjustmentId, productId:this.props.match.params.productId },
            readOnly: true,
        };
        this.costAdjustmentApi = new CostAdjustmentApi();
    }

    componentDidMount() {
        this.costAdjustmentApi.getCostAdjustment(this.state.costAdjustment.productId, this.state.costAdjustment.costAdjustmentId).then(response => {
            this.setState({ costAdjustment: response.data });
            console.log(response.data);
        });
    }

    //Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
        }));
    }

    //Removes the save and cancel button, edit appears again
    handleCancel() {
        console.log("cancelling");
        this.setState(state => ({
            readOnly: !state.readOnly
        }));
    }

    handleSubmit = event => {
        event.preventDefault();
        const productId = this.props.match.params.productId;
        console.log(this.state.product)
        this.costAdjustmentApi.updateCostAdjustment(productId, this.state.costAdjustment).then(response => {
            console.log(response);
            this.setState(state => ({
                readOnly: !state.readOnly
            }));
        });
    }

    renderNavBar() {
        return (
            <ListGroup className="nav flex-column nav-tabs">
                <ListGroupItem className="nav-item">
                    <Link to={`/clubs`} className="nav-link">Clubs</Link>
                </ListGroupItem>
                <ListGroupItem className="nav-item">
                    <Link to={`/costAdjustmentEdit/products/${this.state.costAdjustment.costAdjustmentId}`} className="nav-link">Products</Link>
                </ListGroupItem>
            </ListGroup>
        );
    }

    render() {
        const costAdjustment = this.state.costAdjustment;
        return (
            
            <div className="col-lg-12">
                <h1>Edit Cost Adjustment</h1>
                <div className="row">
                  {this.renderNavBar()}
                  <div className="col-md-10 mt-5">
                  <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col>
                            <Label>CostAdjustment Type</Label>
                            <Input name="name" value={costAdjustment.adjustmentType} readOnly={this.state.readOnly}
                                onChange={(e) => { var x = costAdjustment; x.adjustmentType = e.target.value; this.setState({ costAdjustment: x }) }} />
                        </Col>
                        <Col>
                            <Label>Adjustment</Label>
                            <Input name="costAdjustmentCode" value={costAdjustment.adjustment} readOnly={this.state.readOnly}
                                onChange={(e) => { var x = costAdjustment; x.adjustment = e.target.value; this.setState({ costAdjustment: x }) }} />
                        </Col>
                    </Row>
                    <div className="mt-5">
                        <Row>
                            <Col>

                                <Label>StartDate</Label>
                                <Input type="date" name="startDate" value={formatDate(costAdjustment.startDate)} readOnly={this.state.readOnly}
                             onChange = {(e) => {var x = costAdjustment; x.startDate = e.target.value; this.setState({costAdjustment:x})}}/>
                            </Col>
                            <Col>

                                <Label>EndDate</Label>
                                <Input type="date" name="endDate" value={formatDate(costAdjustment.endDate)} readOnly={this.state.readOnly}
                             onChange = {(e) => {var x = costAdjustment; x.endDate = e.target.value; this.setState({costAdjustment:x})}}/>
                            </Col>
                        </Row>
                    </div>
                    <div className="text-right float-bottom">
                        <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? '' : 'd-none'} color="primary">Edit <FontAwesomeIcon
                            icon="edit"
                        />
                        </Button>
                        <Button type="submit" color="primary" className={this.state.readOnly ? 'd-none' : ''}>Save
                                    </Button>
                        <Button onClick={this.handleCancel.bind(this)} color="primary" className={this.state.readOnly ? 'd-none' : ''}>Cancel
                                    </Button>
                    </div>
                </Form>
                </div>
                </div>
            </div>
            
        );
    }

}
export default CostAdjustmentEdit;